import { useEffect, useRef } from 'react';
export function useTimeout(callback, delay) {
    const callbackRef = useRef(callback);
    useEffect(function updateCallbackRef() {
        callbackRef.current = callback;
    }, [callback]);
    useEffect(function init() {
        const timeout = setTimeout(callbackRef.current, delay);
        return () => {
            clearTimeout(timeout);
        };
    }, [delay]);
}
